import React from 'react';
import A4Page from '../A4Page';
import TopDetail from '../TopDetail';

import { ReactComponent as WhiteFront } from '../../../../../assets/whitefrontalwarning.svg';
import { ReactComponent as WhiteBack } from '../../../../../assets/whitebackwarning.svg';
import { ReactComponent as BlackFront } from '../../../../../assets/blackfrontalwarning.svg';
import { ReactComponent as BlackBack } from '../../../../../assets/blackbackwarning.svg';

import { ReactComponent as Triman25x60 } from '../../../../../assets/zarahome/triman25X60.svg';
import { ReactComponent as Triman25x70 } from '../../../../../assets/zarahome/triman25X70.svg';

import useOrderStore from 'store/client/orderStore';

const Warning_55_120 = React.forwardRef(function Warning_55_120(
  { data, selectColor, tab },
  ref
) {
  // 🔴 TÜM HOOK'LAR HER ZAMAN EN ÜSTE:
  const { referance } = useOrderStore();

  // Sonrasında güvenli okumalar:
  const brandName = (data?.brand?.name || '').toString();
  const refCode   = (data?.referance?.code || '').toString();

  // renk kodu normalize
  const bg = (referance?.backgroundColor || '').toString().trim().toUpperCase();
  const isBlack = bg === 'B' || bg === 'BLACK' || bg === 'K';

  // Guard: data yoksa hiçbir şey çizme (hook'lar zaten çağrıldı)
  if (!data) return null;

  // ZaraHome özel branch
  if (brandName === 'ZaraHome') {
    const isTriman60 = refCode === 'TRIMAN 25X60';
  
    return (
      <div className="flex flex-col items-center" ref={ref}>
        <A4Page type="dikey">
          <div className="space-y-25">
            <TopDetail values={data} selectColor={selectColor} tab={tab} />
          <div style={{display:"flex",flexDirection:"row",alignItems:"center",width:"100%",justifyContent:"center",marginTop:30}}>
            {isTriman60 ? (
              <Triman25x60 style={{ width: '60mm' }} />
            ) : (
              <Triman25x70 style={{ width: '70mm' }} />
            )}
            </div>
          </div>
        </A4Page>
      </div>
    );
  }
  

  // Diğer markalar
  return (
    <div className="flex flex-col items-center" ref={ref}>
      <A4Page type="dikey">
        <div className="space-y-25">
          <TopDetail values={data} selectColor={selectColor} tab={tab} />
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <div style={{ width: '55mm', height: '120mm', marginTop: 15 }}>
              {isBlack ? <BlackFront /> : <WhiteFront />}
            </div>
            <div style={{ width: '55mm', height: '120mm', marginTop: 15, marginLeft: 20 }}>
              {isBlack ? <BlackBack /> : <WhiteBack />}
            </div>
          </div>
        </div>
      </A4Page>
    </div>
  );
});

export default Warning_55_120;
